import {AppFunction} from "../misc/types";
import View from "../framework/view";
import {UsersView} from "../views/users";
import {EditTemplateView} from "../views/edit_template";
import {EditWebsiteView} from "../views/edit_website";
import {EditPageView} from "../views/edit_page";
import {EditMenuView} from "../views/edit_menu";


export class EditWebsiteFunction extends AppFunction {

    readonly v : View;

    constructor() {
        super();
        this.v = new EditWebsiteView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/website/edit`;
    }
}

export class EditPageFunction extends AppFunction {

    readonly v : View;

    private path: string;

    constructor(path: string) {
        super();
        this.path = path;
        this.v = new EditPageView(path);
    }

    view() {
        return this.v;
    }

    url() {
        return `/website/edit/page/${encodeURIComponent(this.path)}`;
    }
}

export class EditMenuFunction extends AppFunction {

    readonly v : View;

    private name: string;

    constructor(name: string) {
        super();
        this.name = name;
        this.v = new EditMenuView(name);
    }

    view() {
        return this.v;
    }

    url() {
        return `/website/edit/menu/${encodeURIComponent(this.name)}`;
    }
}
